// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1_zQp","cls2":"Stats-cls2__WJ Stats-cls1_zQp"};